<div
  data-cy="add-new-vehicle-form"
  ef-feature-id="customerPortal.customer-portal.add-new-vehicle.form"
  class="cpt-modal ef-scrollbar relative dialog-content-p-0 mat-dialog-actions-pb-20"
  [hidden]="hidden"
  >
  <h2 class="font-canelablack-primary text-4xl" mat-dialog-title>
    <T
    str="Add vehicle"
    key="customerPortal.customer-portal.add-new-vehicle.title"
    tags="customer-portal, 3.1"
  ></T>
</h2>
@if (addVehicleForm) {
  <mat-dialog-content class="mat-typography">
    <form
      class="grid grid-cols-1 md:grid-cols-2 gap-y-2.5 gap-x-5 m-0"
      [formGroup]="addVehicleForm"
      >
      <mat-form-field appearance="fill" class="relative" cdkScrollable>
        <mat-label> {{ 'brand' | sharedTranslate }}</mat-label>
        <input
          data-cy="add-new-vehicle-form-brand-input"
          ef-feature-id="customerPortal.customer-portal.add-new-vehicle.brand.input"
          required
          type="text"
          aria-label="Number"
          matInput
          formControlName="brand"
          [matAutocomplete]="auto"
          [errorStateMatcher]="matcher"
          />
        @if (addVehicleForm.get('brand')?.value) {
          <mat-icon
            class="primary absolute right-0 top-3 opacity-60 cursor-pointer"
            svgIcon="close"
            (click)="clearBrand($event)"
          ></mat-icon>
        }
        <mat-autocomplete
          #auto="matAutocomplete"
          autoActiveFirstOption
          requireSelection
          (optionSelected)="getBrandModels()"
          >
          @for (brand of filteredBrands; track brand) {
            <mat-option
              [value]="brand.name | titlecase"
              >
              {{ brand.name | titlecase }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="fill" class="relative" cdkScrollable>
        <mat-label>{{ 'model' | sharedTranslate }}</mat-label>
        <input
          data-cy="add-new-vehicle-form-model-input"
          ef-feature-id="customerPortal.customer-portal.add-new-vehicle.model.input"
          [readonly]="addVehicleForm.get('brand').errors ? true : modelsLoading"
          required
          type="text"
          aria-label="Number"
          matInput
          formControlName="model"
          [matAutocomplete]="modelAutocomplete"
          [errorStateMatcher]="matcher"
          />
        @if (modelsLoading) {
          <mat-spinner matSuffix diameter="20"></mat-spinner>
        }
        @if (addVehicleForm.get('model')?.value && !modelsLoading) {
          <mat-icon
            class="primary absolute right-0 top-3 opacity-60 cursor-pointer"
            svgIcon="close"
            (click)="clearModel($event)"
          ></mat-icon>
        }
        <mat-autocomplete
          #modelAutocomplete="matAutocomplete"
          autoActiveFirstOption
          requireSelection
          >
          @for (model of filteredModels; track model) {
            <mat-option
              [value]="model.name | titlecase"
              >
              {{ model.name | titlecase }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>
          <T
          str="Model line"
          key="customerPortal.customer-portal.add-new-vehicle.modelLine"
          tags="customer-portal, 3.1"
          ></T
        ></mat-label>
        <input
          matInput
          formControlName="modelLine"
          [errorStateMatcher]="matcher"
          />
        @if (addVehicleForm.get('modelLine').errors) {
          <mat-error>
            {{
            transifexService.getErrorTranslation(
            addVehicleForm.get('modelLine'),
            'customerPortal.customer-portal.add-new-vehicle.error.'
            )
            }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label
          ><T
          str="Vehicle identification number (VIN)"
          key="customerPortal.customer-portal.add-new-vehicle.vin"
          tags="customer-portal, 3.1"
          ></T
        ></mat-label>
        <input
          data-cy="add-new-vehicle-form-vin-input"
          ef-feature-id="customerPortal.customer-portal.add-new-vehicle.vin.input"
          pattern="^[a-zA-Z0-9]+$"
          oninput="this.value = this.value.toUpperCase()"
          matInput
          required
          formControlName="vin"
          [errorStateMatcher]="matcher"
          />
        @if (addVehicleForm.get('vin').errors) {
          <mat-error
            data-cy="add-new-vehicle-form-vin-error"
            ef-feature-id="customerPortal.customer-portal.add-new-vehicle.vin.error"
            >
            {{
            transifexService.getErrorTranslation(
            addVehicleForm.get('vin'),
            'customerPortal.customer-portal.add-new-vehicle.error.vin.'
            )
            }}
          </mat-error>
        }
      </mat-form-field>
      <div class="w-full relative mt-4 md:mt-0">
        <mat-checkbox
          data-cy="add-new-vehicle-form-other-LP-checkbox"
          ef-feature-id="customerPortal.customer-portal.add-new-vehicle.other-licence-plate.checkbox"
          class="h-6 text-sm absolute top-[-22px] right-0 font-normal"
          color="primary"
          #checkbox_otherLicencePlate
          (change)="otherLicencePlateChanged(checkbox_otherLicencePlate)"
          >
          <T
          str="Other license plate"
          key="customerPortal.customer-portal.add-new-vehicle.otherlicencePlate"
          tags="customer-portal, 3.8"
        ></T>
      </mat-checkbox>
      @if (otherLicencePlateCheckbox) {
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>
            <T
            str="License plate"
            key="customerPortal.customer-portal.add-new-vehicle.licencePlate"
            tags="customer-portal, 3.1"
            ></T
          ></mat-label>
          <input
            data-cy="add-new-vehicle-form-other-LP-input"
            ef-feature-id="customerPortal.customer-portal.add-new-vehicle.other-licence-plate.input"
            oninput="this.value = this.value.toUpperCase()"
            matInput
            required
            formControlName="otherLicencePlate"
            [errorStateMatcher]="matcher"
            />
          @if (addVehicleForm.get('otherLicencePlate').errors) {
            <mat-error
              data-cy="add-new-vehicle-form-licence-plate-error"
              ef-feature-id="customerPortal.customer-portal.add-new-vehicle.licence-plate.error"
              >
              {{
              transifexService.getErrorTranslation(
              addVehicleForm.get('otherLicencePlate'),
              'customerPortal.customer-portal.add-new-vehicle.error.'
              )
              }}
            </mat-error>
          }
        </mat-form-field>
      }
      @if (!otherLicencePlateCheckbox) {
        @if (country === 'de') {
          <mat-form-field
            appearance="fill"
            class="w-full"
            >
            <mat-label>
              <T
              str="License plate"
              key="customerPortal.customer-portal.add-new-vehicle.licencePlate"
              tags="customer-portal, 3.1"
              ></T
            ></mat-label>
            <input
              data-cy="add-new-vehicle-form-licence-plate-input"
              ef-feature-id="customerPortal.customer-portal.add-new-vehicle.licence-plate.input"
              oninput="this.value = this.value.toUpperCase()"
              matInput
              required
              formControlName="licencePlateDE"
              [errorStateMatcher]="matcher"
              />
            @if (addVehicleForm.get('licencePlateDE').errors) {
              <mat-error
                data-cy="add-new-vehicle-form-licence-plate-error"
                ef-feature-id="customerPortal.customer-portal.add-new-vehicle.licence-plate.error"
                >
                {{
                transifexService.getErrorTranslation(
                addVehicleForm.get('licencePlateDE'),
                'customerPortal.customer-portal.add-new-vehicle.error.'
                )
                }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (country === 'ch') {
          <div class="grid grid-cols-5 gap-2.5 w-full">
            <mat-form-field
              class="col-span-1 md:col-span-2 hidden md:inline-block"
              appearance="fill"
              >
              <mat-label
                ><T
                str="Canton"
                key="customerPortal.customer-portal.vehicle.details.registration-plate-canton"
                tags="customer-portal, 3.1"
                ></T
              ></mat-label>
              <mat-select
                data-cy="add-new-vehicle-form-licence-plate-canton-select"
                ef-feature-id="customerPortal.customer-portal.add-new-vehicle.licence-plate.canton.select"
                formControlName="licencePlateCanton"
                required
                [(ngModel)]="canton"
                [errorStateMatcher]="matcher"
                (selectionChange)="cantonChanged()"
                >
                @for (k of cantons; track k) {
                  <mat-option [value]="k.id">
                    {{ k.id }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field
              class="col-span-1 md:col-span-2 inline-block md:hidden"
              appearance="fill"
              >
              <mat-label
                ><T
                str="Canton"
                key="customerPortal.customer-portal.vehicle.details.registration-plate-canton"
                tags="customer-portal, 3.1"
                ></T
              ></mat-label>
              <select
                formControlName="licencePlateCanton"
                matNativeControl
                class="pb-0 mt-0.5"
                [(ngModel)]="canton"
                required
                (selectionChange)="cantonChanged()"
                >
                @for (k of cantons; track k) {
                  <option [value]="k.id">
                    {{ k.id }}
                  </option>
                }
              </select>
            </mat-form-field>
            <mat-form-field
              class="col-span-4 md:col-span-3"
              appearance="fill"
              >
              <mat-label
                ><T
                str="License plate"
                key="customerPortal.customer-portal.add-new-vehicle.licencePlate"
                tags="customer-portal, 3.1"
                ></T
              ></mat-label>
              <input
                data-cy="add-new-vehicle-form-licence-plate-input"
                ef-feature-id="customerPortal.customer-portal.add-new-vehicle.licence-plate.input"
                oninput="this.value = this.value.toUpperCase()"
                matInput
                required
                formControlName="licencePlateCH"
                [errorStateMatcher]="matcher"
                />
              @if (addVehicleForm.get('licencePlateCH').errors) {
                <mat-error
                  data-cy="add-new-vehicle-form-licence-plate-error"
                  ef-feature-id="customerPortal.customer-portal.add-new-vehicle.licence-plate.error"
                  >
                  {{
                  transifexService.getErrorTranslation(
                  addVehicleForm.get('licencePlateCH'),
                  'customerPortal.customer-portal.add-new-vehicle.error.'
                  )
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <mat-form-field appearance="fill">
      <mat-label
        ><T
        str="Current Mileage"
        key="customerPortal.customer-portal.add-new-vehicle.currentMileage"
        tags="customer-portal, 3.1"
        ></T
      ></mat-label>
      <input
        data-cy="add-new-vehicle-form-mileage-input"
        ef-feature-id="customerPortal.customer-portal.add-new-vehicle.mileage.input"
        type="number"
        pattern="[0-9]+"
        matInput
        formControlName="manualMileage"
        [errorStateMatcher]="matcher"
        />
      @if (addVehicleForm.get('manualMileage').errors) {
        <mat-error
          data-cy="add-new-vehicle-form-mileage-error"
          ef-feature-id="customerPortal.customer-portal.add-new-vehicle.mileage.error"
          >
          {{
          transifexService.getErrorTranslation(
          addVehicleForm.get('manualMileage'),
          'customerPortal.customer-portal.add-new-vehicle.error.'
          )
          }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>
        <T str="First registration" key="customerPortal.customer-portal.add-new-vehicle.firstRegistration"
      tags="customer-portal, 3.1"></T>
    </mat-label>
    <input
      data-cy="add-new-vehicle-form-first-registration-input"
      ef-feature-id="customerPortal.customer-portal.add-new-vehicle.first-registration.input"
      matInput
      (click)="pickerFR.open()"
      [max]="now"
      readonly
      required
      datePickerFormat={{dateFormat}}
      [matDatepicker]="pickerFR"
      formControlName="firstRegistration"
      />
    <mat-datepicker-toggle
      class="calendar-size"
      matPrefix
      [for]="pickerFR"
    ></mat-datepicker-toggle>
    <mat-datepicker
      [calendarHeaderComponent]="customHeader"
      #pickerFR
      startView="multi-year"
      (yearSelected)="chosenYearHandler($event, 'firstRegistration')"
          (monthSelected)="
            chosenMonthHandler($event, pickerFR, 'firstRegistration')
          "
      (opened)="addScrolling(pickerFR)"
      >
    </mat-datepicker>
    <span (click)="pickerFR.open()" matSuffix>
      <mat-icon class="primary" svgIcon="create"></mat-icon>
    </span>
    @if (addVehicleForm.controls.firstRegistration.invalid) {
      <mat-error>
        {{
        transifexService.getErrorTranslation(
        addVehicleForm.controls.firstRegistration,
        'customerPortal.customer-portal.add-new-vehicle.error.'
        )
        }}
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>
      <T str="Lease expires" key="customerPortal.customer-portal.add-new-vehicle.leasingExpiry"
    tags="customer-portal, 3.1"></T>
  </mat-label>
  <input
    matInput
    (click)="pickerLE.open()"
    [min]="now"
    [max]="fiveYearsAfter"
    readonly
    [matDatepicker]="pickerLE"
    datePickerFormat={{dateFormat}}
    formControlName="leasingExpiry"
    />
  <mat-datepicker-toggle
    class="calendar-size"
    matPrefix
    [for]="pickerLE"
  ></mat-datepicker-toggle>
  <mat-datepicker
    [calendarHeaderComponent]="customHeader"
    #pickerLE
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event, 'leasingExpiry')"
          (monthSelected)="
            chosenMonthHandler($event, pickerLE, 'leasingExpiry')
          "
    (opened)="addScrolling(pickerLE)"
    >
  </mat-datepicker>
  <span (click)="pickerLE.open()" matSuffix>
    <mat-icon class="primary" svgIcon="create"></mat-icon>
  </span>
  @if (addVehicleForm.controls.leasingExpiry.invalid) {
    <mat-error>
      {{
      transifexService.getErrorTranslation(
      addVehicleForm.controls.leasingExpiry,
      'customerPortal.customer-portal.add-new-vehicle.error.'
      )
      }}
    </mat-error>
  }
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>
    <T str="Next appointment" key="customerPortal.customer-portal.add-new-vehicle.nextService"
  tags="customer-portal, 3.1"></T>
</mat-label>
<input
  matInput
  (click)="picker.open()"
  [min]="now"
  [max]="fiveYearsAfter"
  readonly
  [matDatepicker]="picker"
  datePickerFormat={{dateFormat}}
  formControlName="nextService"
  />
<mat-datepicker-toggle
  class="calendar-size"
  matPrefix
  [for]="picker"
></mat-datepicker-toggle>
<mat-datepicker
  [calendarHeaderComponent]="customHeader"
  #picker
  startView="multi-year"
  (yearSelected)="chosenYearHandler($event, 'nextService')"
  (monthSelected)="chosenMonthHandler($event, picker, 'nextService')"
  (opened)="addScrolling(picker)"
  >
</mat-datepicker>
<span (click)="picker.open()" matSuffix>
  <mat-icon class="primary" svgIcon="create"></mat-icon>
</span>
@if (addVehicleForm.controls.nextService.invalid) {
  <mat-error>
    {{
    transifexService.getErrorTranslation(
    addVehicleForm.controls.nextService,
    'customerPortal.customer-portal.add-new-vehicle.error.'
    )
    }}
  </mat-error>
}
</mat-form-field>
</form>
</mat-dialog-content>
}
<mat-divider></mat-divider>
<mat-dialog-actions>
  <button class="dialog-close-button" [mat-dialog-close]="false">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <button
    data-cy="add-new-vehicle-form-submit"
    ef-feature-id="customerPortal.customer-portal.add-new-vehicle.submit.button"
    id="saveButton"
    [disabled]="saving || !addVehicleForm.valid"
    mat-button
    mat-flat-button
    color="secondary"
    class="revolution w-full md:w-auto text-base h-12 px-20"
    (click)="addVehicle()"
    cdkFocusInitial
    >
    @if (saving) {
      <mat-spinner diameter="20"></mat-spinner>
    }
    {{ 'save' | sharedTranslate }}
  </button>
</mat-dialog-actions>
</div>
